import React from 'react';
import { Modal, List, Row, Col, Space, Card } from 'antd';

import { useModalState } from 'hooks/useModalState';
import { getColmanagerByColid } from 'services/collection';
import { useQuery } from 'react-query';
import moment from 'moment';
import GetLabel from 'DisplayFramework/components/GetLabel';

type managermodalProps = {
  colid: number;
  managername: string;
  //  refetchBrokerList: () => void;
};

const Managermodal = (props: managermodalProps) => {
  const { colid, managername } = props;

  const { data } = useQuery(['getColmanagerByColid', { colid }], () =>
    getColmanagerByColid({ colid }).then((res) => res.list || {})
  );

  const { close, open, visible } = useModalState();

  return (<>
    <a
      onClick={(e) => {
        e.preventDefault();
        open();
      }}
    >
      {managername}
    </a>
    <Modal
      title={<GetLabel label="ManagementDetails" />}
      open={visible}
      onCancel={close}
      footer={null}
      width={800}
    >
      <Card>
        <List
          size="small"
          bordered
          dataSource={data ?? []}
          renderItem={(item) => {
            return (
              <List.Item>
                <Row gutter={32}>
                  <Col>
                    <Space size="small">
                      <div>
                        <GetLabel label="UserName" />:
                      </div>
                      <b>{item.username}</b>
                    </Space>
                  </Col>

                  <Col>
                    <Space size="small">
                      <div>
                        <GetLabel label="Startdate" />:
                      </div>
                      <b>
                        {item.startdate !== null && item.startdate !== ''
                          ? moment(item.startdate).format('YYYY-MM-DD')
                          : ''}
                      </b>
                    </Space>
                  </Col>
                  <Col>
                    <Space size="small">
                      <div>
                        <GetLabel label="Enddate" />:
                      </div>
                      <b>
                        {item.enddate !== null && item.enddate !== ''
                          ? moment(item.enddate).format('YYYY-MM-DD')
                          : ''}
                      </b>
                    </Space>
                  </Col>
                </Row>
              </List.Item>
            );
          }}
        />
      </Card>
    </Modal>
  </>);
};

export default Managermodal;
